export interface MarketplaceNotification {
  id: string;
  title: string;
  body: string;
  channel: NotificationChannel;
  status: NotificationStatus;
  createTime: string;
  readAt: string | null;
  eventType: NotificationEventType;
}

export interface MarketplaceNotificationUnreadCount {
  count: number;
}

export interface MarketplaceNotificationPreference {
  eventType: NotificationEventType;
  emailEnabled: boolean;
  smsEnabled: boolean;
  pushEnabled: boolean;
  inAppEnabled: boolean;
}

export interface MarketplaceNotificationPagedResult {
  items: MarketplaceNotification[];
  totalCount: number;
}

export interface MarketplaceNotificationHubInfo {
  hubUrl: string;
  accessToken: string;
  notificationReceivedMethod: string;
  branchId: string;
}

export interface MarketplaceNotificationRealtime {
  id: string;
  title: string;
  body: string;
  storeId: string;
  channel: NotificationChannel;
  eventType: NotificationEventType;
  createTime: string;
}

export enum NotificationChannel {
  Email = 1,
  Sms = 2,
  Push = 4,
  InApp = 8,
  WhatsApp = 16
}

export enum NotificationStatus {
  Pending = 1,
  Processing = 2,
  Sent = 3,
  Failed = 4,
  Cancelled = 5,
  Read = 6,
  DeadLettered = 7
}

export enum NotificationEventType {
  OrderCreated = 1,
  OrderPaid = 2,
  OrderShipped = 3,
  OrderDelivered = 4,
  OrderCancelled = 5,
  ReturnRequested = 6,
  PaymentFailed = 7,
  ProductApproved = 8,
  ProductRejected = 9,
  LowStockWarning = 10,
  CampaignStarted = 11,
  NewQuestionReceived = 12,
  NewReviewReceived = 13
}

export const NOTIFICATION_EVENT_TYPE_LABELS: Record<NotificationEventType, string> = {
  [NotificationEventType.OrderCreated]: 'Sipariş Oluşturuldu',
  [NotificationEventType.OrderPaid]: 'Sipariş Ödendi',
  [NotificationEventType.OrderShipped]: 'Sipariş Kargoya Verildi',
  [NotificationEventType.OrderDelivered]: 'Sipariş Teslim Edildi',
  [NotificationEventType.OrderCancelled]: 'Sipariş İptal Edildi',
  [NotificationEventType.ReturnRequested]: 'İade Talebi',
  [NotificationEventType.PaymentFailed]: 'Ödeme Başarısız',
  [NotificationEventType.ProductApproved]: 'Ürün Onaylandı',
  [NotificationEventType.ProductRejected]: 'Ürün Reddedildi',
  [NotificationEventType.LowStockWarning]: 'Düşük Stok Uyarısı',
  [NotificationEventType.CampaignStarted]: 'Kampanya Başladı',
  [NotificationEventType.NewQuestionReceived]: 'Yeni Soru',
  [NotificationEventType.NewReviewReceived]: 'Yeni Değerlendirme'
};

export const NOTIFICATION_EVENT_TYPE_ICONS: Record<NotificationEventType, string> = {
  [NotificationEventType.OrderCreated]:      'fas fa-cart-plus',
  [NotificationEventType.OrderPaid]:         'fas fa-money-bill-wave',
  [NotificationEventType.OrderShipped]:      'fas fa-truck',
  [NotificationEventType.OrderDelivered]:    'fas fa-box-open',
  [NotificationEventType.OrderCancelled]:    'fas fa-ban',
  [NotificationEventType.ReturnRequested]:   'fas fa-undo',
  [NotificationEventType.PaymentFailed]:     'fas fa-exclamation-circle',
  [NotificationEventType.ProductApproved]:   'fas fa-check-circle',
  [NotificationEventType.ProductRejected]:   'fas fa-times-circle',
  [NotificationEventType.LowStockWarning]:   'fas fa-exclamation-triangle',
  [NotificationEventType.CampaignStarted]:   'fas fa-tag',
  [NotificationEventType.NewQuestionReceived]: 'fas fa-question-circle',
  [NotificationEventType.NewReviewReceived]: 'fas fa-star'
};

export function getNotificationStatusClass(status: NotificationStatus): string {
  switch (status) {
    case NotificationStatus.Read: return 'badge-soft-success';
    case NotificationStatus.Sent: return 'badge-soft-info';
    case NotificationStatus.Failed: return 'badge-soft-danger';
    case NotificationStatus.Cancelled: return 'badge-soft-secondary';
    case NotificationStatus.Pending: return 'badge-soft-warning';
    case NotificationStatus.Processing: return 'badge-soft-primary';
    default: return 'badge-soft-secondary';
  }
}

export function getNotificationStatusLabel(status: NotificationStatus): string {
  switch (status) {
    case NotificationStatus.Pending: return 'Bekliyor';
    case NotificationStatus.Processing: return 'İşleniyor';
    case NotificationStatus.Sent: return 'Gönderildi';
    case NotificationStatus.Failed: return 'Başarısız';
    case NotificationStatus.Cancelled: return 'İptal';
    case NotificationStatus.Read: return 'Okundu';
    case NotificationStatus.DeadLettered: return 'Teslim Edilemedi';
    default: return '-';
  }
}
